module.exports = __webpack_public_path__ + "img/pic27.dc48cb9b.jpg";